import Vue from 'vue'
import Vuex from 'vuex'
import category from "./modules/category";
import menu from "./modules/menu";
import toppings from "./modules/toppings";
import orders from "./modules/orders";
import auth from "./modules/auth";
Vue.use(Vuex)

export default new Vuex.Store({
  modules:{
    category,
    menu,
    toppings,
    orders,
    auth
  }
});
